import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    // Allowed paths for Content Writer role
    private readonly CONTENT_WRITER_ALLOWED_PATHS = [
        'blogs',
        'add-blog',
        'account',
        'writers',
        'add-writer',
        'authors',
        'add-author',
        'samples',
        'add-sample',
    ];

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this.authenticationService.get_currentUserValue();

        if (!currentUser) {
            // Not logged in, redirect to login
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
            return false;
        }

        // If user is not Content Writer, allow access
        if (currentUser.role !== 'Content Writer') {
            return true;
        }

        // Content Writer - check if path is allowed
        const urlPath = state.url.split('?')[0].split('/').filter(segment => segment !== '');

        // Check if the first path segment matches allowed paths
        // or if it's an edit/dynamic route (edit-blog/:id, edit-writer/:id, edit-author/:id, blog/:id, page-preview/:id)
        if (urlPath.length > 0) {
            const mainPath = urlPath[0];

            // Check exact matches
            if (this.CONTENT_WRITER_ALLOWED_PATHS.includes(mainPath)) {
                return true;
            }

            // Check dynamic routes with IDs
            if (urlPath.length === 2) {
                const pathWithParam = `${mainPath}/:id`;
                const allowedDynamicPaths = [
                    'edit-blog/:id',
                    'blog/:id',
                    'edit-writer/:id',
                    'edit-author/:id',
                    'page-preview/:id',
                    'edit-sample/:id',
                ];

                if (allowedDynamicPaths.some(allowed => allowed === pathWithParam)) {
                    return true;
                }
            }
        }

        // Path not allowed for Content Writer, redirect to blogs
        console.warn(`Access denied for Content Writer to path: ${state.url}`);
        this.router.navigate(['/blogs']);
        return false;
    }
}
